import { Checkbox } from '../Common/Checkbox';
import { useTranslate } from '@/hooks/useTranslate';

interface SaveCardCheckboxProps {
  isSaveCard: boolean;
  setIsSaveCard: (value: boolean) => void;
}

export const SaveCardCheckbox = ({ isSaveCard, setIsSaveCard }: SaveCardCheckboxProps) => {
  const { t } = useTranslate();

  const handleClick = () => {
    setIsSaveCard(!isSaveCard);
  };

  return (
    <div
      data-testid="save-card-checkbox-wrapper"
      className="flex items-center w-full gap-2 cursor-pointer"
      onClick={handleClick}
    >
      <Checkbox data-testid="save-card-checkbox" checked={isSaveCard} />
      <div data-testid="save-card-label" className="text-sm text-primary font-medium">
        {t('saveCardCheckbox')}
      </div>
    </div>
  );
};
